import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ScheduledSongsContextType {
  recentScheduledSongs: any[];
  setRecentScheduledSongs: (songs: any[]) => void;
}

const ScheduledSongsContext = createContext<ScheduledSongsContextType | undefined>(undefined);

export const ScheduledSongsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [recentScheduledSongs, setRecentScheduledSongs] = useState<any[]>([]);

  // Wrapper to ensure only arrays are set
  const safeSetRecentScheduledSongs = (songs: any) => {
    if (Array.isArray(songs)) {
      setRecentScheduledSongs(songs);
    } else {
      console.warn('Attempted to set non-array value to recentScheduledSongs, defaulting to empty array');
      setRecentScheduledSongs([]);
    }
  };

  return (
    <ScheduledSongsContext.Provider value={{ recentScheduledSongs, setRecentScheduledSongs: safeSetRecentScheduledSongs }}>
      {children}
    </ScheduledSongsContext.Provider>
  );
};

export const useScheduledSongs = () => {
  const context = useContext(ScheduledSongsContext);
  if (context === undefined) {
    throw new Error('useScheduledSongs must be used within a ScheduledSongsProvider');
  }
  return context;
};
